module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNi43NiA2Ny44OCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzViNWI1Yjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93LWxlZnQtc3dpcGVyPC90aXRsZT48cG9seWdvbiBjbGFzcz0iYSIgcG9pbnRzPSIwIDMzLjk0IDMzLjk0IDY3Ljg4IDM2Ljc2IDY1LjA1IDUuNjUgMzMuOTQgMzYuNzYgMi44MyAzMy45NCAwIDAgMzMuOTQgMCAzMy45NCAwIDMzLjk0Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-left-swiper.svg
// module id = tQIv
// module chunks = 0